export default __webpack_public_path__ + "static/media/applogo.14c63c11.png";